// import Vestibular from './components/Vestibular'
import Etapas from './components/etapas/Etapas'
import Finalizacao from './components/etapas/Finalizacao'

export default [
  {
    path: '/vestibular',
    // component: Vestibular,
    beforeEnter: () => {
      window.location.href = 'https://vestibular.urcamp.edu.br/'
    },
    name: 'vestibular',
    meta: {
      breadcrumb: {
        name: 'Vestibular'
      },
      auth: false
    }
  },
  {
    path: '/etapas',
    component: Etapas,
    name: 'etapas',
    meta: {
      breadcrumb: {
        name: 'Etapas inscrição do vestibular'
      },
      auth: false
    }
  },
  {
    path: '/etapas/selecao-cursos',
    component: Etapas,
    name: 'selecao-cursos',
    meta: {
      breadcrumb: {
        name: 'Seleção de curso'
      },
      auth: false
    }
  },
  {
    path: '/etapas/dados-pessoais',
    component: Etapas,
    name: 'dados-pessoais',
    meta: {
      breadcrumb: {
        name: 'Cadastro de informações pessoais'
      },
      auth: false
    }
  },
  {
    path: '/etapas/confirmacao',
    component: Etapas,
    name: 'confirmacao',
    meta: {
      breadcrumb: {
        name: 'Confirmação da inscrição'
      },
      auth: false
    }
  },
  {
    path: '/etapas/finalizacao',
    component: Finalizacao,
    name: 'finalizacao',
    meta: {
      breadcrumb: {
        name: 'Inscrição finalizada'
      },
      auth: false
    }
  }
]



// WEBPACK FOOTER //
// ./src/app/domains/vestibular/routes.js